module.exports = __webpack_public_path__ + "img/eatDorado_de.9f7d1776.png";